// Utility functions for date handling

/**
 * Converts a German date string (dd.mm.yyyy) to ISO format (yyyy-MM-dd)
 */
export const germanDateToIsoDate = (germanDate: string): string => {
  if (!germanDate) return ''
  const parts = germanDate.split('.')
  if (parts.length !== 3) return ''
  return `${parts[2]}-${parts[1]}-${parts[0]}`
}

/**
 * Converts an ISO date string (yyyy-MM-dd) to German format (dd.mm.yyyy)
 */
export const isoDateToGermanDate = (isoDate: string): string => {
  if (!isoDate) return ''
  const parts = isoDate.split('-')
  if (parts.length !== 3) return ''
  return `${parts[2]}.${parts[1]}.${parts[0]}`
}

/**
 * Normalizes any date string to ISO format (yyyy-MM-dd)
 */
export const normalizeToIsoDate = (dateString: string): string => {
  if (!dateString) return ''
  if (dateString.match(/^\d{4}-\d{2}-\d{2}$/)) {
    return dateString
  } else if (dateString.match(/^\d{2}\.\d{2}\.\d{4}$/)) {
    return germanDateToIsoDate(dateString)
  } else {
    try {
      const dateObj = new Date(dateString)
      if (!isNaN(dateObj.getTime())) {
        const year = dateObj.getFullYear()
        const month = String(dateObj.getMonth() + 1).padStart(2, '0')
        const day = String(dateObj.getDate()).padStart(2, '0')
        return `${year}-${month}-${day}`
      }
    } catch (e) {
      console.error('Invalid date format:', dateString)
    }
  }
  return ''
}
